/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'antd';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/New/arrow-down-icon.svg';
import { FILTER_DROPDOWN_TYPE } from 'helpers/constants';
import FilterDropdownList from 'components/New/FilterDropdown/List'
import FilterDropdownChoosing from 'components/New/FilterDropdown/Choosing'
import FilterDropdownDate from 'components/New/FilterDropdown/Date'
import FilterDropdownFooter from 'components/New/FilterDropdown/Footer'
import { ICON_MAPPING } from './constants';
import classes from './FilterBar.module.scss';

const mockListItems = [
  {
    id: 1,
    value: 'supplierA',
    label: 'Supplier A'
  },
  {
    id: 2,
    value: 'supplierB',
    label: 'Supplier B'
  },
  {
    id: 3,
    value: 'supplierC',
    label: 'Supplier C'
  },
]
const mockChoosingItems = [
  {
    id: 1,
    value: 'za',
    label: 'High to Low'
  },
  {
    id: 2,
    value: 'az',
    label: 'Low to High'
  },
]
const mockDateItems1 = [
  {
    id: 1,
    value: 'created_at',
    label: 'Create Date'
  },
  {
    id: 2,
    value: 'last_modified_at',
    label: 'Last Modified'
  },
]
const mockDateItems2 = [
  {
    id: 1,
    value: 'nto',
    label: 'Newest to Oldest'
  },
  {
    id: 2,
    value: 'otn',
    label: 'Oldest to Newest'
  },
]

const FilterItem = ({ item = {}, isReset, isDisabled, children, defaultChecks, defaultDate, onApply, onReset }) => {
  const [open, setOpen] = useState(false);
  const [checks, setChecks] = useState([]);
  const [dateVal, setDateVal] = useState(null);

  const hasDropdown = !isEmpty(item.dropdown);
  const liItem = (
    <li className={cn(classes.item, {
      [classes.reset]: isReset,
      [classes.disabled]: isDisabled,
    })}>
      {children || (
        <>
        <span className={classes.icon}>{item.icon || ICON_MAPPING[item.type]}</span>
      <span className={classes.label}>{item.label}</span>
      <span className={classes.arrow}>
        <ArrowDownIcon />
      </span>
        </>
      )}
    </li>
  );
  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      if (!isEqual(defaultChecks, checks)) {
        setChecks(defaultChecks);
      }
      if (!isEqual(defaultDate, dateVal)) {
        setDateVal(defaultDate);
      }
    }
  }, [open])
  

  if (!hasDropdown) {
    return liItem;
  }

  return (
    <Dropdown
      menu={{
        items: [],
      }}
      dropdownRender={() => {
        return (
          <div className={classes.dropdownContent}>
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.LIST && (<FilterDropdownList hasAll items={mockListItems} checks={checks} setChecks={setChecks} />)}
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.CHOOSING && (<FilterDropdownChoosing checks={checks} setChecks={setChecks} items={mockChoosingItems} />)}
            {item.dropdown?.type === FILTER_DROPDOWN_TYPE.DATE && (<FilterDropdownDate items={{
              field: mockDateItems1,
              method: mockDateItems2
            }} checks={checks} setChecks={setChecks} dateVal={dateVal} setDateVal={setDateVal} />)}
            <FilterDropdownFooter onApply={() => {
              setOpen(false);
              onApply(checks);
            }} onReset={() => {
              setChecks(defaultChecks);
              setOpen(false);
              onReset(defaultChecks)
            }}  />
          </div>
        );
      }}
      trigger={['click']}
      onOpenChange={handleOpenChange}
      open={open}
      overlayClassName={classes.dropdownOverlay}
    >
      {liItem}
    </Dropdown>
  );
}

export default FilterItem;